import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import CV from "@/pages/CV";
import Login from "@/pages/Login";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminPosts from "@/pages/admin/AdminPosts";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminCV from "@/pages/admin/AdminCV";
import PostEditor from "@/pages/admin/PostEditor";

function App() {
  return (
    <div className="App bg-paper text-ink font-body">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/new" element={<Navigate to="/admin/posts/new" replace />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/cv" element={<CV />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminPosts />} />
                <Route path="projects" element={<AdminProjects />} />
                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="cv" element={<AdminCV />} />
              </Route>
              <Route path="/admin/posts/new" element={<ProtectedRoute><PostEditor /></ProtectedRoute>} />
              <Route path="/admin/posts/:slug" element={<ProtectedRoute><PostEditor /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
